type AcquisitionPageType =
  | "home"
  | "product"
  | "pricing"
  | "integration"
  | "guide"
  | "alternatives"
  | "comparison";

export const ACQUISITION_PAGES: Readonly<
  Record<string, { id: string; type: AcquisitionPageType }>
> = {
  "/": { id: "C01", type: "home" },
  "/what-is-y2": { id: "C02", type: "product" },
  "/pricing": { id: "C03", type: "pricing" },
  "/developers": { id: "C04", type: "integration" },
  "/solutions/intelligence-briefings": { id: "C05", type: "product" },
  "/blog/mcp-server-for-osint": { id: "C06", type: "guide" },
  "/blog/best-osint-aggregation-tools-2026": {
    id: "C07",
    type: "alternatives",
  },
  "/blog/palantir-alternative-gotham-class-platforms-smaller-security-teams": {
    id: "C08",
    type: "alternatives",
  },
  "/blog/feedly-alternatives-for-intelligence-briefings": {
    id: "C09",
    type: "alternatives",
  },
  "/blog/y2-vs-perigon-intelligence-briefings": {
    id: "C11",
    type: "comparison",
  },
};

// Page-level classification only. Entry and conversion attribution use the existing session events.
export function acquisitionPageProperties(pathname: string) {
  const path = pathname.split(/[?#]/, 1)[0].replace(/\/+$/, "") || "/";
  const page = Object.hasOwn(ACQUISITION_PAGES, path)
    ? ACQUISITION_PAGES[path]
    : undefined;
  return page
    ? { acquisition_page_id: page.id, acquisition_page_type: page.type }
    : {};
}
